import React, { useState } from 'react'
import { Col } from 'react-bootstrap'
import TagManager from 'react-gtm-module'
import {
  DownloadPdfIcon,
  useErrorService,
  useUserService,
} from '@abroad/components'
import API from '../../utils/API'
import SessionEvent from '../../constants/events'

const AttachKeyResources = ({ pdfData, sessionId }) => {
  const [isDownloadLoading, setIsDownloadLoading] = useState(false)
  const Error = useErrorService()
  const { user } = useUserService()
  const userId = user?.id

  const downloadKeySkillHandler = (title) => {
    //GTM code
    TagManager.dataLayer({
      dataLayer: {
        event: SessionEvent.event.sessionKeySkills,
        eventProps: {
          category: SessionEvent.category.sessionKeySkillsCategory,
          action: 'User download recommended key skills',
          label: 'Download recommended key skills',
          value: `User download recommended key skills, title is ${title}`,
          userId,
        },
      },
    })
  }

  const handleDownloadPDF = async () => {
    try {
      setIsDownloadLoading(true)
      const { data } = await API.programs.getURLForSkillPDF(
        pdfData?.subCategoryId,
        pdfData?._id,
        sessionId,
      )
      downloadKeySkillHandler(`${pdfData?.title} (PDF)`)
      if (data) {
        window.open(data.url.url)
        setIsDownloadLoading(false)
      }
    } catch (e) {
      setIsDownloadLoading(false)
      Error.showError(e)
    }
  }

  return (
    <Col
      key={pdfData?.programId}
      className='col-12 col-lg-7 mx-auto mx-lg-0 border-radius-10 pt-1 cursor-pointer d-flex align-items-center space-x-3 my-1 ps-0'>
      <DownloadPdfIcon
        size={40}
        isLoading={isDownloadLoading}
        disabled={isDownloadLoading}
        onClick={handleDownloadPDF}
        className='d-flex align-self-center flex-grow-1'
      />
      <div className='d-flex flex-column justify-content-start flex-shrink-10'>
        <p className='font-open-sans font-bold font-14 mb-0 truncate leading-6 text-left font-montserrat'>
          {pdfData?.title} (PDF)
        </p>
        <span className='font-montserrat font-semibold font-10 text-left text-uppercase tracking-md-wide'>
          {pdfData?.description}
        </span>
      </div>
    </Col>
  )
}

export default AttachKeyResources
